import { z } from 'zod/v4-mini';

import { GeneralBackendResponseSchema } from '$/services/mapper/authentication';
import { UserSchema } from '$/services/usecases/authentication/mapper/genericCloudResponse';

export const SchoolSchema = z.object({
  id: z.string(),
  isActive: z.boolean(),
  countryId: z.string(),
  name: z.string(),
  address: z.string(),
  requesterId: z.string(),
  department: z.string(),
  phone: z.string(),
  website: z.string(),
  deputyId: z.nullable(z.string()),
});

export type School = z.infer<typeof SchoolSchema>;

export const SchoolWithRequesterSchema = z.object({
  ...SchoolSchema.shape,
  requesterEmail: z.string(),
  requesterName: z.string(),
});

export type SchoolWithRequester = z.infer<typeof SchoolWithRequesterSchema>;

export const GetSchoolsResponseSchema = z.object({
  ...GeneralBackendResponseSchema,
  payload: z.array(SchoolWithRequesterSchema),
});

export const GetSchoolByIdResponseSchema = z.object({
  ...GeneralBackendResponseSchema,
  payload: SchoolSchema,
});

export const GetSchoolTeachersResponseSchema = z.object({
  ...GeneralBackendResponseSchema,
  payload: z.array(UserSchema),
});

export const AcceptTeacherInvitationResponseSchema = z.object({
  ...GeneralBackendResponseSchema,
  payload: z.optional(z.object({ otpToken: z.string() })),
});
